/**
 * @author Iulian Ceapa <dev@sitemd.net>
 * @copyright © 2019-2026 SiteMD.
 */

const swiper_section_1 = new Swiper('#section-1 .swiper', {
    grabCursor: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    pagination: {
        el: '.swiper-pagination',
    },
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true
});

const swiper_section_2 = new Swiper('#section-2 .swiper', {
    breakpoints: {
        0: {
            slidesPerView: 'auto',
            spaceBetween: 16
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 24
        },
        1200: {
            slidesPerView: 'auto'
        },
        1400: {
            slidesPerView: 4
        }
    },
    grabCursor: true,
    slidesPerView: 4,
    spaceBetween: 24,
    loop: false
});